/**
 * The colours of every Giving surface, built from the portal's own green (#5CB891 with the
 * #f0faf5 fill its selected cards use) and its emerald and orange text tones.
 */
export const DONATION_TONE = {
  /** A card that is about a donation. */
  card: 'border-[#5CB891]/40 bg-[#f0faf5]',
  text: 'text-emerald-700',
  iconTile: 'bg-[#5CB891]/15 text-emerald-700',
  pill: 'bg-[#5CB891]/15 text-emerald-700',
  filledButton:
    'bg-emerald-700 text-white hover:bg-emerald-700/90 focus-visible:ring-emerald-700',
  outlineButton:
    'border border-[#5CB891] bg-white text-emerald-700 hover:bg-[#f0faf5] hover:text-emerald-700 focus-visible:ring-emerald-700',
  /** Waiting on the gateway, or on something from the donor. */
  pending: 'border-orange-200 bg-orange-50',
  pendingText: 'text-orange-700'
} as const;

export const DONATION_NON_REFUNDABLE = 'Non-refundable';

export const charityDonationsPath = (charityId: string, year: number) =>
  `/donations/charities/${charityId}?year=${year}`;

/**
 * The version of the consent line on the Add IC sheet. Bump it with any change to that line's
 * wording; the backend refuses a save against a version that is not current.
 */
export const IC_CONSENT_TEXT_VERSION = 1;

/** What a donor reads when a receipt or summary can't be downloaded. Never a code. */
export const RECEIPT_DOWNLOAD_MESSAGES = {
  nameRequired:
    'Your receipt needs your name. Add it in Settings, then download it again.',
  emailRequired:
    'Your receipt needs your email address. Add it in Settings, then download it again.',
  tooManyDownloads:
    "You've downloaded several files in a row. Please wait a minute, then try again.",
  busy: "We're preparing a lot of files right now. Please try again in a minute.",
  bundleTooLarge:
    "There are too many receipts for one file. Please download them one at a time from this charity's list of donations.",
  summaryTooLarge:
    'There are too many donations this year for one summary file. Please contact support for a copy.',
  failed: "We couldn't download the file. Please try again."
} as const;

/** What a donor reads when the Add IC sheet can't save. */
export const IC_SAVE_MESSAGES = {
  exists:
    'An IC number is already saved on your account. Please contact support to change it.',
  invalid: "That IC number doesn't look right. Please check it and try again.",
  outdated: 'This page is out of date. Please reload it and try again.',
  notApplicable:
    "Your receipts don't need an IC number, so we didn't save it. You can download them as they are.",
  failed: "We couldn't save your IC number. Please try again."
} as const;
